import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-keep-button",
  templateUrl: "./keep-button.component.html",
  styleUrl: "./keep-button.component.scss",
})
export class KeepButtonComponent {
  @Input() isRecommended: boolean = false;
  @Input() isDelistRecommended: boolean = false;
  @Input() btnDisable: boolean = false;
  @Input() isActive: boolean = false;
  @Input() btnSize: string = "";
  @Input() hostingFrom: string = "";
  @Output() actionBtnCallback = new EventEmitter<any>();

  onBtnClick() {
    this.actionBtnCallback.emit();
  }
}
